import React, { useMemo, useState } from 'react';
import { Block } from '@webfox-sc/core';
import { useDownloads } from './useDownloads';
import HeadlineTwo from '../elements/HeadlineTwo';
import './attended-download-list.scss';
import AssetItem from './AssetItem';
import AssetsWrapper from './AssetsWrapper';

const AttendedDownloadList = () => {
  const { attendedPastDownloads, getFlattenedAssets } = useDownloads();
  const [selectedDownloads, setSelectedDownloads] = useState([]);

  const allAssets = useMemo(() => getFlattenedAssets(selectedDownloads), [selectedDownloads, getFlattenedAssets]);

  const toggleDownloadSelection = (download) => {
    setSelectedDownloads((prevSelected) => {
      const exists = prevSelected.find((d) => d.id === download.id);
      if (exists) {
        return prevSelected.filter((d) => d.id !== download.id);
      }
      return [...prevSelected, download];
    });
  };

  return (
    <Block
      className={`bt-attended-download-list ${
        selectedDownloads.length > 0 ? 'bt-attended-download-list--has-selection' : ''
      }`}
    >
      <Block className="bt-attended-download-list__headline">
        <HeadlineTwo text="Courses You Attended" />
      </Block>

      {attendedPastDownloads.length > 0 ? (
        <Block className="bt-attended-download-list__filter-container">
          {attendedPastDownloads.map((download) => {
            const isSelected = selectedDownloads.some((d) => d.id === download.id);
            return (
              <Block
                className={`bt-attended-download-list__filter ${
                  isSelected ? 'bt-attended-download-list__filter--selected' : ''
                }`}
                key={download.id}
                onClick={() => toggleDownloadSelection(download)}
                role="button"
                tabIndex={0}
              >
                <p className="bt-attended-download-list__filter-title">{download.title}</p>
                <p className="bt-attended-download-list__filter-info">{download.datum?.date}</p>
              </Block>
            );
          })}
        </Block>
      ) : (
        <Block className="bt-attended-download-list__no-results">No results found</Block>
      )}

      {allAssets.length > 0 && (
        <Block className="bt-attended-download-list__assets">
          <AssetsWrapper>
            {allAssets.map((asset, index) => (
              <AssetItem key={`${asset.type}-${index}`} asset={asset} />
            ))}
          </AssetsWrapper>
        </Block>
      )}
    </Block>
  );
};

AttendedDownloadList.propTypes = {};
AttendedDownloadList.defaultProps = {};

export default AttendedDownloadList;
